import { QueryClient } from "@tanstack/react-query";
import { isRetryableError } from "./client";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => failureCount < 2 && isRetryableError(error),
      retryDelay: (attempt) => Math.min(8_000, 500 * 2 ** attempt),
    },
    mutations: { retry: 0 },
  },
});
